import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sun, Sunrise, Sunset, Sparkles, Moon } from "lucide-react";

export default function PanchangWidget() {
  const [p, setP] = useState(null);
  const [rashi, setRashi] = useState([]);
  const [selectedRashi, setSelectedRashi] = useState(0);
  useEffect(() => {
    api.get("/panchang/today").then((r) => setP(r.data)).catch(() => {});
    api.get("/rashifal/today").then((r) => setRashi(r.data)).catch(() => {});
  }, []);
  if (!p) return null;
  const sel = rashi[selectedRashi];
  return (
    <section className="my-8 bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 border-2 border-amber-200 rounded-xl overflow-hidden" data-testid="panchang-widget">
      {/* Panchang */}
      <div className="p-5 border-b border-amber-200">
        <div className="flex items-center gap-2 mb-3">
          <Sun className="w-5 h-5 text-amber-600"/>
          <h3 className="font-devnagri-heading font-black text-xl text-[#0F172A]">आज का पंचांग</h3>
          <span className="text-xs text-slate-500 ml-auto">{p.weekday} · {p.hindu_month} · {p.date}</span>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <PanchInfo icon={Moon} label="तिथि" value={p.tithi}/>
          <PanchInfo icon={Sparkles} label="नक्षत्र" value={p.nakshatra}/>
          <PanchInfo icon={Sunrise} label="सूर्योदय" value={p.sunrise}/>
          <PanchInfo icon={Sunset} label="सूर्यास्त" value={p.sunset}/>
        </div>
        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
          <div className="bg-white/70 rounded px-3 py-2"><b className="text-amber-800">शुभ मुहूर्त:</b> {p.shubh_muhurat}</div>
          <div className="bg-white/70 rounded px-3 py-2"><b className="text-red-700">राहुकाल:</b> {p.rahu_kaal}</div>
        </div>
      </div>
      {/* Rashifal */}
      {rashi.length > 0 && (
        <div className="p-5">
          <h3 className="font-devnagri-heading font-black text-xl text-[#0F172A] mb-3 flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-amber-600"/>आज का राशिफल
          </h3>
          <div className="grid grid-cols-6 sm:grid-cols-12 gap-1.5 mb-3">
            {rashi.map((r, i) => (
              <button key={r.en} onClick={() => setSelectedRashi(i)}
                className={`text-center py-1.5 rounded text-xs transition ${
                  selectedRashi === i ? "bg-[#0F172A] text-white font-bold" : "bg-white text-slate-700 hover:bg-amber-100"
                }`} data-testid={`rashi-${r.en}`}>
                {r.rashi}
              </button>
            ))}
          </div>
          {sel && (
            <div className="bg-white rounded-lg p-4 border border-amber-200">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 text-white flex items-center justify-center font-black">
                  {sel.rashi[0]}
                </div>
                <div>
                  <div className="font-bold text-[#0F172A]">{sel.rashi} <span className="text-xs text-slate-500">({sel.en})</span></div>
                  <div className="flex gap-3 text-[10px] mt-0.5">
                    <span>शुभ रंग: <b className="text-amber-700">{sel.color}</b></span>
                    <span>भाग्यांक: <b className="text-emerald-700">{sel.luck}/10</b></span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-slate-700 leading-relaxed">{sel.message}</p>
            </div>
          )}
        </div>
      )}
    </section>
  );
}

function PanchInfo({ icon: Icon, label, value }) {
  return (
    <div className="bg-white/80 rounded-lg p-2.5 flex items-center gap-2">
      <Icon className="w-4 h-4 text-amber-600 shrink-0"/>
      <div className="min-w-0">
        <div className="text-[9px] uppercase tracking-widest text-slate-500 font-bold">{label}</div>
        <div className="text-sm font-bold text-[#0F172A] truncate">{value}</div>
      </div>
    </div>
  );
}
